<template>
  <gv-menu class="flex max-h-[500px] max-w-[600px] flex-col p-[24px_8px_24px_24px]">
    <ui-map-guide-tab-list />

    <div class="flex overflow-y-scroll pr-4">
      <ui-map-guide-polygons
        v-show="mapGuide.mapGuidePage === MapGuidePage.Polygons"
        :id="`panel_${sanitizePageId(MapGuidePage.Polygons)}`"
        :aria-labelledby="`tab_${sanitizePageId(MapGuidePage.Polygons)}`"
        role="tabpanel"
      />
      <ui-map-guide-weather
        v-show="mapGuide.mapGuidePage === MapGuidePage.Weather"
        :id="`panel_${sanitizePageId(MapGuidePage.Weather)}`"
        :aria-labelledby="`tab_${sanitizePageId(MapGuidePage.Weather)}`"
        role="tabpanel"
      />
      <ui-map-guide-fire-danger
        v-show="mapGuide.mapGuidePage === MapGuidePage.FireDanger"
        :id="`panel_ ${sanitizePageId(MapGuidePage.FireDanger)}`"
        :aria-labelledby="`tab_${sanitizePageId(MapGuidePage.FireDanger)}`"
        role="tabpanel"
      />
      <ui-map-guide-total-fire-bans
        v-show="mapGuide.mapGuidePage === MapGuidePage.TotalFireBans"
        :id="`panel_${sanitizePageId(MapGuidePage.TotalFireBans)}`"
        :aria-labelledby="`tab_${sanitizePageId(MapGuidePage.TotalFireBans)}`"
        role="tabpanel"
      />
    </div>
  </gv-menu>
</template>

<script setup lang="ts">
import { MapGuidePage, sanitizePageId, useMapGuideStore } from '@/features';

const mapGuide = useMapGuideStore();
</script>
